import { render, staticRenderFns } from "./addCar.vue?vue&type=template&id=38fe6664&scoped=true"
import script from "./addCar.vue?vue&type=script&lang=js"
export * from "./addCar.vue?vue&type=script&lang=js"
import style0 from "./addCar.vue?vue&type=style&index=0&id=38fe6664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fe6664",
  null
  
)

export default component.exports